import ThemeBackground from "@pathwright/ui/src/components/background/ThemeBackground"
import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import ScrollView from "@pathwright/ui/src/components/scroll/ScrollView"
import Tab from "@pathwright/ui/src/components/tab/Tab"
import View from "@pathwright/ui/src/components/ui/View"
import { media } from "@pathwright/ui/src/components/utils/styles"
import get from "lodash/get"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { useUserProfileQuery } from "../api/generated"
import UserInbox from "../inbox/UserInbox"
import ProfileActivity from "./ProfileActivity"
import ProfileRegistrations from "./ProfileRegistrations"
import ProfileUserCard from "./ProfileUserCard"

const StyledContainer = styled(View.Secondary)`
  position: relative;
  display: flex;
  flex-direction: column;
  ${media.min.phone`max-height:calc(100vh - 100px);`};

  .CompletionsList__nav {
    display: none;
  }
`

const StyledTabs = styled.ul`
  position: relative;
  margin: 0;
  padding: 0;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  background-color: white;
`

const StyledTab = styled(Tab)`
  margin: 0;
`

const StyledScrollView = styled(ScrollView)`
  background-color: transparent !important;
  border-radius: 0 0 10px 10px;
  position: relative;
  min-height: 250px;
  flex-grow: 1;

  .UserInbox {
    margin-top: 0 !important;
  }
`

const ProfileReview = ({ userId }) => {
  return <UserInbox userId={userId} />
}

const tabNames = {
  registrations: "Paths",
  activity: "Activity",
  review: "Review"
}

const tabKeys = Object.freeze(Object.keys(tabNames))

const Profile = ({ tabKey: tabKeyProp, showTabs, userId }) => {
  const [tabKey, setTabKey] = useState(tabKeyProp || "registrations")

  useEffect(() => {
    if (tabKeyProp && tabKeyProp !== tabKey) setTabKey(tabKeyProp)
  }, [tabKeyProp])

  const userQuery = useUserProfileQuery({
    variables: {
      id: userId
    }
  })

  const { error, loading } = userQuery
  const user = get(userQuery, "data.user")

  if (loading) {
    return null
  }

  if (error) {
    console.warn(error.message)
    return (
      <BlankSlate
        icon="caution-triangle"
        body={`An unexpected error occurred: ${error.message}`}
      />
    )
  }

  return (
    <StyledContainer className="ProfileCard" rounded>
      {tabKey === "activity" && <ThemeBackground roundedBottom />}
      <ProfileUserCard user={user} px="40px" w="100%" borderRadius="none" />
      <StyledTabs className="ProfileCard__tabs">
        {showTabs.map((showTabKey) => (
          <StyledTab
            key={showTabKey}
            active={tabKey === showTabKey}
            onClick={() => setTabKey(showTabKey)}
          >
            {tabNames[showTabKey]}
          </StyledTab>
        ))}
      </StyledTabs>
      <StyledScrollView className="ProfileCard__tab_content">
        {tabKey === "activity" ? (
          <ProfileActivity userId={user.id} singleColumn />
        ) : tabKey === "registrations" ? (
          <ProfileRegistrations userId={user.id} />
        ) : (
          <ProfileReview userId={user.id} />
        )}
      </StyledScrollView>
    </StyledContainer>
  )
}

Profile.displayName = "Profile"

Profile.propTypes = {
  tabKey: PropTypes.oneOf(tabKeys),
  showTabs: PropTypes.arrayOf(PropTypes.oneOf(tabKeys)),
  userId: PropTypes.number.isRequired
}

Profile.defaultProps = {
  showTabs: tabKeys
}

export default Profile
